const FORGOTPASSWORD = {
  heading: {
    title: 'Forgot Password?',
    subtitle:
      'Enter the email address for your BoostHiring account below and we will email you a link to reset your password.',
    submitSucceededText: 'Please, check your email address',
  },
  button: 'Reset password',
  link: 'Go back to Sign In',
};

export default FORGOTPASSWORD;
